module.exports = __webpack_public_path__ + "img/hot.08092938.png";